.root {
  background-image: url("../../../assets/illustrations/loader.webp");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 220px;
}
